import { useRef } from 'react';

import { Mail01Icon } from '@hugeicons/core-free-icons';
import { useTranslation } from 'react-i18next';

import { AnimatedModal } from 'components/AnimatedModal/AnimatedModal';
import { EmailTemplateForm } from 'components/EmailTemplateForm/EmailTemplateForm';
import { Button } from 'components/FormComponents';

export const EmailTemplateModal = ({
  visible,
  onClose,
  onSubmit,
  initialValues,
  isLoading,
  brands = [],
}) => {
  const { t } = useTranslation();
  const formRef = useRef(null);

  const title = initialValues?.id
    ? t('emailTemplates.modal.editTitle')
    : t('emailTemplates.modal.createTitle');

  return (
    <AnimatedModal
      icon={Mail01Icon}
      oldIconLibrary={false}
      visible={visible}
      onClose={onClose}
      title={title}
      headerActions={
        <Button type="primary" loading={isLoading} onClick={() => formRef.current?.submit()}>
          {t('emailTemplates.form.save')}
        </Button>
      }
      fullscreen>
      {visible && (
        <EmailTemplateForm
          ref={formRef}
          key={initialValues?.id ?? 'new'}
          initialValues={initialValues}
          onSubmit={onSubmit}
          onCancel={onClose}
          isLoading={isLoading}
          brands={brands}
          hideFooterActions
        />
      )}
    </AnimatedModal>
  );
};
